export default "__VITE_ASSET__Cd$tPOBP__"